<template>
  <v-container fluid>
    <SidebarNavigation />

    <v-card>
      <v-tabs v-model="tab">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab v-for="(item, index) in tabItems" :key="index">
          <span>{{ item.name }}</span>
          <v-badge
            v-if="item.total"
            class="mb-3"
            :content="item.total"
            color="red"
            inline
          ></v-badge>
        </v-tab>
      </v-tabs>
    </v-card>

    <v-card>
      <v-tabs-items v-model="tab">
        <!-- verification -->
        <v-tab-item>
          <v-row class="pt-3 pl-1 justify-end">
            <!-- Tahun  -->
            <v-col cols="auto" class="mt-5">
              <v-menu
                v-model="pagination.startMenu"
                :close-on-content-click="false"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    readonly
                    v-model="pagination.startDate"
                    label="Tahun"
                    v-bind="attrs"
                    v-on="on"
                    dense
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="pagination.startDate"
                  @input="onDateChange('start')"
                  locale="id"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <!-- Tanggal Akhir -->
            <!-- <v-col cols="auto" class="mt-5">
              <v-menu
                v-model="pagination.endMenu"
                :close-on-content-click="false"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    readonly
                    v-model="pagination.endDate"
                    label="Tanggal Akhir"
                    v-bind="attrs"
                    v-on="on"
                    dense
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="pagination.endDate"
                  @input="onDateChange"
                  locale="id"
                ></v-date-picker>
              </v-menu>
            </v-col> -->

            <!-- Search -->
            <v-col cols="auto" class="mt-5 mr-1">
              <v-text-field
                v-model="pagination.search"
                label="Search"
                append-icon="mdi-magnify"
                dense
                hide-details
                class="search-input"
                style="max-width: 250px"
                outlined
                @input="debouncedSearch"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-data-table
                fixed-header
                dense
                class="elevation-5 custome-table"
                :headers="tableHeaders"
                :items="implementsList"
                :items-per-page.sync="pagination.itemsPerPage"
                :page.sync="pagination.page"
                :sort-by="pagination.sortBy"
                :sort-desc="pagination.sortDesc"
                :loading="isLoading"
                :server-items-length="totalImplements"
                item-key="id"
                @update:page="updateQuery('page', $event)"
                @update:items-per-page="updateQuery('itemsPerPage', $event)"
                @update:sort-by="updateQuery('sortBy', $event)"
                @update:sort-desc="updateQuery('sortDesc', $event)"
              >
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.id">
                      <td>
                        <span
                          color="transparent"
                          class="text-none"
                          @click="openDialogSuggestionDetail(item)"
                        >
                          {{ item.title }}
                        </span>
                      </td>
                      <td>{{ item.suggestion_category_name }}</td>
                      <td>{{ formatRupiah(item.benefit) }}</td>

                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                              icon
                              @click="
                                openDialogHistoriApproval(item.suggestion_id)
                              "
                            >
                              <v-icon>mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          Tampilkan
                        </v-tooltip>
                      </td>
                      <td>
                        <div v-if="item.file_names">
                          <v-icon
                            v-for="(fileName, index) in item.file_names.split(
                              '|'
                            )"
                            :key="index"
                            color="primary"
                            @click="
                              downloadAttachment(item.suggestion_id, fileName)
                            "
                          >
                            <!-- Menampilkan ikon berdasarkan ekstensi fileName -->
                            <template v-if="fileName.slice(1) == '.xlsx'">
                              mdi-file-excel-outline
                            </template>
                            <template
                              v-else-if="
                                fileName.slice(1) == '.jpeg' ||
                                fileName.slice(1) == '.png' ||
                                fileName.slice(1) == '.jpeg' ||
                                fileName.slice(1) == '.jpg'
                              "
                            >
                              mdi-image
                            </template>
                            <template v-else-if="fileName.slice(1) == '.pdf'">
                              mdi-file-pdf-box
                            </template>
                            <template v-else>
                              mdi-file-download-outline
                            </template>
                          </v-icon>
                        </div>
                      </td>
                      <td>
                        <div style="font-size: 12px">
                          {{ item.created_by_name }}
                        </div>
                        <div style="font-size: 12px">
                          {{ item.mst_division_name }}
                        </div>
                        <div style="font-size: 12px">{{ item.created_on }}</div>
                      </td>
                      <td>
                        <div class="d-flex" v-if="user.mst_division_id == 5">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                small
                                color="success"
                                v-bind="attrs"
                                v-on="on"
                                icon
                                @click="openDialogVerification(item)"
                              >
                                <v-icon>mdi-check</v-icon>
                              </v-btn>
                            </template>
                            Approve
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                small
                                icon
                                color="red"
                                @click="openDialogReject(item)"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </template>
                            Reject
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                small
                                icon
                                color="warning"
                                @click="openDialogTbr(item)"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon>mdi-skip-previous</v-icon>
                              </v-btn>
                            </template>
                            To Be Revised
                          </v-tooltip>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-tab-item>

        <!-- verified / input score -->
        <v-tab-item>
          <v-row class="pt-3 pl-1 justify-end">
            <!-- Tahun  -->
            <v-col cols="auto" class="mt-5">
              <v-menu
                v-model="paginationVerified.startMenu"
                :close-on-content-click="false"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    readonly
                    v-model="paginationVerified.startDate"
                    label="Tahun"
                    v-bind="attrs"
                    v-on="on"
                    dense
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="paginationVerified.startDate"
                  @input="onDateChangeVerified('start')"
                  locale="id"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <!-- Tanggal Akhir -->
            <!-- <v-col cols="auto" class="mt-5">
              <v-menu
                v-model="paginationVerified.endMenu"
                :close-on-content-click="false"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    readonly
                    v-model="paginationVerified.endDate"
                    label="Tanggal Akhir"
                    v-bind="attrs"
                    v-on="on"
                    dense
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="paginationVerified.endDate"
                  @input="onDateChangeVerified"
                  locale="id"
                ></v-date-picker>
              </v-menu>
            </v-col> -->

            <!-- Search -->
            <v-col cols="auto" class="mt-5 mr-1">
              <v-text-field
                v-model="paginationVerified.search"
                label="Search"
                append-icon="mdi-magnify"
                dense
                hide-details
                class="search-input"
                style="max-width: 250px"
                outlined
                @input="debouncedSearchVerified"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-data-table
                fixed-header
                dense
                class="elevation-5 custome-table"
                :headers="tableHeadersVerified"
                :items="implementsListVerified"
                :items-per-page.sync="paginationVerified.itemsPerPage"
                :page.sync="paginationVerified.page"
                :sort-by="paginationVerified.sortBy"
                :sort-desc="paginationVerified.sortDesc"
                :loading="isLoadingVerified"
                :server-items-length="totalImplementsVerified"
                item-key="id"
                @update:page="updateQueryVerified('page', $event)"
                @update:items-per-page="
                  updateQueryVerified('itemsPerPage', $event)
                "
                @update:sort-by="updateQueryVerified('sortBy', $event)"
                @update:sort-desc="updateQueryVerified('sortDesc', $event)"
              >
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.id">
                      <td>
                        <span
                          color="transparent"
                          class="text-none"
                          @click="openDialogSuggestionDetail(item)"
                        >
                          {{ item.title }}
                        </span>
                      </td>
                      <td>{{ item.suggestion_category_name }}</td>
                      <td>{{ formatRupiah(item.benefit) }}</td>

                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                              icon
                              @click="
                                openDialogHistoriApproval(item.suggestion_id)
                              "
                            >
                              <v-icon>mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          Tampilkan
                        </v-tooltip>
                      </td>

                      <td>
                        <div v-if="item.file_names">
                          <v-icon
                            v-for="(fileName, index) in item.file_names.split(
                              '|'
                            )"
                            :key="index"
                            color="primary"
                            @click="
                              downloadAttachment(item.suggestion_id, fileName)
                            "
                          >
                            <!-- Menampilkan ikon berdasarkan ekstensi fileName -->
                            <template v-if="fileName.slice(1) == '.xlsx'">
                              mdi-file-excel-outline
                            </template>
                            <template
                              v-else-if="
                                fileName.slice(1) == '.jpeg' ||
                                fileName.slice(1) == '.png' ||
                                fileName.slice(1) == '.jpeg' ||
                                fileName.slice(1) == '.jpg'
                              "
                            >
                              mdi-image
                            </template>
                            <template v-else-if="fileName.slice(1) == '.pdf'">
                              mdi-file-pdf-box
                            </template>
                            <template v-else>
                              mdi-file-download-outline
                            </template>
                          </v-icon>
                        </div>
                      </td>
                      <!-- <td>
                        <v-btn
                          color="white"
                          small
                          @click="fetchImplementDetail(item.id, 'all')"
                        >
                          {{ item.total_score }}
                        </v-btn>
                      </td> -->
                      <td>
                        <div style="font-size: 12px">
                          {{ item.created_by_name }}
                        </div>
                        <div style="font-size: 12px">
                          {{ item.mst_division_name }}
                        </div>
                        <div style="font-size: 12px">{{ item.created_on }}</div>
                      </td>
                      <td>
                        <v-tooltip
                          bottom
                          v-if="
                            user.mst_division_id == 5 &&
                            item.next_sequence_score == 1
                          "
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              icon
                              color="primary"
                              @click="
                                openDialogInputScore(
                                  item,
                                  item.next_sequence_score
                                )
                              "
                            >
                              <v-icon>mdi-import</v-icon>
                            </v-btn>
                          </template>
                          {{ `Input Score Setelah Implementasi` }}
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-tab-item>

        <!-- top ten -->
        <v-tab-item>
          <v-row class="pt-3 pl-1 justify-end">
            <!-- Tahun  -->
            <v-col cols="auto" class="mt-5">
              <v-menu
                v-model="paginationTopTen.startMenu"
                :close-on-content-click="false"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    readonly
                    v-model="paginationTopTen.startDate"
                    label="Tahun"
                    v-bind="attrs"
                    v-on="on"
                    dense
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="paginationTopTen.startDate"
                  @input="onDateChangeTopTen('start')"
                  locale="id"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <!-- Tanggal Akhir -->
            <!-- <v-col cols="auto" class="mt-5">
              <v-menu
                v-model="paginationTopTen.endMenu"
                :close-on-content-click="false"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    readonly
                    v-model="paginationTopTen.endDate"
                    label="Tanggal Akhir"
                    v-bind="attrs"
                    v-on="on"
                    dense
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="paginationTopTen.endDate"
                  @input="onDateChangeTopTen"
                  locale="id"
                ></v-date-picker>
              </v-menu>
            </v-col> -->

            <!-- Search -->
            <v-col cols="auto" class="mt-5 mr-1">
              <v-text-field
                v-model="paginationTopTen.search"
                label="Search"
                append-icon="mdi-magnify"
                dense
                hide-details
                class="search-input"
                style="max-width: 250px"
                outlined
                @input="debouncedSearchTopTen"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-data-table
                fixed-header
                dense
                class="elevation-5 custome-table"
                :headers="tableHeadersTopTen"
                :items="implementsListTopTen"
                :items-per-page.sync="paginationTopTen.itemsPerPage"
                :page.sync="paginationTopTen.page"
                :sort-by="paginationTopTen.sortBy"
                :sort-desc="paginationTopTen.sortDesc"
                :loading="isLoadingTopTen"
                @update:sort-by="updateQuery('sortBy', $event)"
                @update:sort-desc="updateQuery('sortDesc', $event)"
                hide-default-footer
              >
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.id">
                      <td>
                        <span
                          color="transparent"
                          class="text-none"
                          @click="openDialogSuggestionDetail(item)"
                        >
                          {{ item.title }}
                        </span>
                      </td>
                      <td>{{ item.suggestion_category_name }}</td>
                      <td>{{ formatRupiah(item.benefit) }}</td>
                      <!-- <td>{{ formatRupiah(item.realization_benefit) }}</td> -->

                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                              icon
                              @click="
                                openDialogHistoriApproval(item.suggestion_id)
                              "
                            >
                              <v-icon>mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          Tampilkan
                        </v-tooltip>
                      </td>
                      <td>
                        <div v-if="item.file_names">
                          <v-icon
                            v-for="(fileName, index) in item.file_names.split(
                              '|'
                            )"
                            :key="index"
                            color="primary"
                            @click="
                              downloadAttachment(item.suggestion_id, fileName)
                            "
                          >
                            <!-- Menampilkan ikon berdasarkan ekstensi fileName -->
                            <template v-if="fileName.slice(1) == '.xlsx'">
                              mdi-file-excel-outline
                            </template>
                            <template
                              v-else-if="
                                fileName.slice(1) == '.jpeg' ||
                                fileName.slice(1) == '.png' ||
                                fileName.slice(1) == '.jpeg' ||
                                fileName.slice(1) == '.jpg'
                              "
                            >
                              mdi-image
                            </template>
                            <template v-else-if="fileName.slice(1) == '.pdf'">
                              mdi-file-pdf-box
                            </template>
                            <template v-else>
                              mdi-file-download-outline
                            </template>
                          </v-icon>
                        </div>
                      </td>
                      <td>
                        <!-- <v-checkbox
                          v-if="
                            user.mst_division_id == 5 &&
                            item.next_sequence_score == 3
                          "
                          v-model="item.is_top_idea"
                          @click="openDialogConfirmTopIdea(item)"
                          color="success"
                          hide-details
                          density="comfortable"
                        ></v-checkbox> -->

                        <div v-if="item.file_names_materi">
                          <v-icon
                            v-for="(fileName, index) in fileList(
                              item.file_names_materi
                            )"
                            :key="`icon-${index}`"
                            color="primary"
                            @click="
                              downloadMateri(item.suggestion_id, fileName)
                            "
                          >
                            {{ getFileIcon(fileName) }}
                          </v-icon>
                        </div>
                      </td>
                      <td>
                        <v-btn
                          color="white"
                          small
                          @click="fetchImplementDetail(item.id, '1')"
                        >
                          {{ item.total_score }}
                        </v-btn>
                      </td>
                      <td>
                        <span
                          v-if="item.is_top_ten"
                          class="mdi mdi-check-decagram-outline"
                          style="color: green; font-size: 24px"
                        ></span>
                      </td>

                      <td>
                        <div style="font-size: 12px">
                          {{ item.created_by_name }}
                        </div>
                        <div style="font-size: 12px">
                          {{ item.mst_division_name }}
                        </div>
                        <div style="font-size: 12px">{{ item.created_on }}</div>
                      </td>

                      <td>
                        <span class="d-flex align-center">
                          <!-- <v-tooltip
                            bottom
                            v-if="user.mst_division_id == 5 && !item.is_top_ten"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                x-small
                                v-bind="attrs"
                                v-on="on"
                                icon
                                color="primary"
                                @click="openDialogConfirmTopTen(item)"
                              >
                                <v-icon>mdi mdi-check-circle</v-icon>
                              </v-btn>
                            </template>
                            {{ `Konfirmasi Top Ten` }}
                          </v-tooltip> -->
                          <v-tooltip
                            x-small
                            bottom
                            v-if="
                              user.mst_division_id == 5 &&
                              item.next_sequence_score == 2 &&
                              item.is_top_ten &&
                              isShowBtnInputScoreTopIdea
                            "
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                color="primary"
                                @click="
                                  openDialogInputScore(
                                    item,
                                    item.next_sequence_score
                                  )
                                "
                              >
                                <v-icon>mdi-import</v-icon>
                              </v-btn>
                            </template>
                            {{ `Input Score Setelah Presentasi` }}
                          </v-tooltip>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  @click="openDialogDone"
                  :disabled="isDisabledDone"
                  >Selesai</v-btn
                >
              </v-card-actions>
            </v-col>
          </v-row>
        </v-tab-item>

        <!-- top idea -->
        <v-tab-item>
          <v-row class="pt-3 pl-1 justify-end">
            <!-- Tahun  -->
            <v-col cols="auto" class="mt-5">
              <v-menu
                v-model="paginationTopIdea.startMenu"
                :close-on-content-click="false"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    readonly
                    v-model="paginationTopIdea.startDate"
                    label="Tahun"
                    v-bind="attrs"
                    v-on="on"
                    dense
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="paginationTopIdea.startDate"
                  @input="onDateChangeTopIdea('start')"
                  locale="id"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <!-- Tanggal Akhir -->
            <!-- <v-col cols="auto" class="mt-5">
              <v-menu
                v-model="paginationTopIdea.endMenu"
                :close-on-content-click="false"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    readonly
                    v-model="paginationTopIdea.endDate"
                    label="Tanggal Akhir"
                    v-bind="attrs"
                    v-on="on"
                    dense
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="paginationTopIdea.endDate"
                  @input="onDateChangeTopIdea"
                  locale="id"
                ></v-date-picker>
              </v-menu>
            </v-col> -->

            <!-- Search -->
            <v-col cols="auto" class="mt-5 mr-1">
              <v-text-field
                v-model="paginationTopIdea.search"
                label="Search"
                append-icon="mdi-magnify"
                dense
                hide-details
                class="search-input"
                style="max-width: 250px"
                outlined
                @input="debouncedSearchTopIdea"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-data-table
                fixed-header
                dense
                class="elevation-5 custome-table"
                :headers="tableHeadersTopIdea"
                :items="implementsListTopIdea"
                :items-per-page.sync="paginationTopIdea.itemsPerPage"
                :page.sync="paginationTopIdea.page"
                :sort-by="paginationTopIdea.sortBy"
                :sort-desc="paginationTopIdea.sortDesc"
                :loading="isLoadingTopIdea"
                @update:sort-by="updateQuery('sortBy', $event)"
                @update:sort-desc="updateQuery('sortDesc', $event)"
                hide-default-footer
              >
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="(item, index) in items" :key="item.id">
                      <td>
                        <span
                          color="transparent"
                          class="text-none"
                          @click="openDialogSuggestionDetail(item)"
                        >
                          {{ item.title }}
                        </span>
                      </td>
                      <td>{{ item.suggestion_category_name }}</td>
                      <td>{{ formatRupiah(item.benefit) }}</td>
                      <td>{{ formatRupiah(item.realization_benefit) }}</td>

                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                              icon
                              @click="
                                openDialogHistoriApproval(item.suggestion_id)
                              "
                            >
                              <v-icon>mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          Tampilkan
                        </v-tooltip>
                      </td>
                      <td>
                        <div v-if="item.file_names">
                          <v-icon
                            v-for="(fileName, index) in item.file_names.split(
                              '|'
                            )"
                            :key="index"
                            color="primary"
                            @click="
                              downloadAttachment(item.suggestion_id, fileName)
                            "
                          >
                            <!-- Menampilkan ikon berdasarkan ekstensi fileName -->
                            <template v-if="fileName.slice(1) == '.xlsx'">
                              mdi-file-excel-outline
                            </template>
                            <template
                              v-else-if="
                                fileName.slice(1) == '.jpeg' ||
                                fileName.slice(1) == '.png' ||
                                fileName.slice(1) == '.jpeg' ||
                                fileName.slice(1) == '.jpg'
                              "
                            >
                              mdi-image
                            </template>
                            <template v-else-if="fileName.slice(1) == '.pdf'">
                              mdi-file-pdf-box
                            </template>
                            <template v-else>
                              mdi-file-download-outline
                            </template>
                          </v-icon>
                        </div>
                      </td>
                      <td>
                        <!-- <v-checkbox
                          v-if="
                            user.mst_division_id == 5 &&
                            item.next_sequence_score == 3
                          "
                          v-model="item.is_top_idea"
                          @click="openDialogConfirmTopIdea(item)"
                          color="success"
                          hide-details
                          density="comfortable"
                        ></v-checkbox> -->

                        <div v-if="item.file_names_materi">
                          <v-icon
                            v-for="(fileName, index) in fileList(
                              item.file_names_materi
                            )"
                            :key="`icon-${index}`"
                            color="primary"
                            @click="
                              downloadMateri(item.suggestion_id, fileName)
                            "
                          >
                            {{ getFileIcon(fileName) }}
                          </v-icon>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex">
                          <v-btn
                            color="white"
                            small
                            @click="fetchImplementDetail(item.id, 2)"
                          >
                            {{ item.total_score }}
                          </v-btn>
                          <img
                            v-if="index === 0"
                            src="@/assets/gold.png"
                            alt="Gold"
                            class="flip-animation"
                          />
                          <img
                            v-if="index === 1"
                            src="@/assets/silver.png"
                            alt="Gold"
                            class="flip-animation"
                          />
                          <img
                            v-if="index === 2"
                            src="@/assets/bronze.png"
                            alt="Gold"
                            class="flip-animation"
                          />
                        </div>
                      </td>

                      <td>
                        <span
                          v-if="item.is_top_idea"
                          class="mdi mdi-check-decagram-outline"
                          style="color: green; font-size: 24px"
                        ></span>
                      </td>

                      <td>
                        <div style="font-size: 12px">
                          {{ item.created_by_name }}
                        </div>
                        <div style="font-size: 12px">
                          {{ item.mst_division_name }}
                        </div>
                        <div style="font-size: 12px">{{ item.created_on }}</div>
                      </td>
                      <td>
                        <div class="d-flex">
                          <v-tooltip
                            bottom
                            v-if="
                              user.mst_division_id == 5 &&
                              !item.is_top_idea &&
                              index < 3
                            "
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                color="primary"
                                @click="openDialogConfirmTopIdea(item, index)"
                              >
                                <v-icon>mdi mdi-check-circle</v-icon>
                              </v-btn>
                            </template>
                            {{ `Konfirmasi Top Idea` }}
                          </v-tooltip>
                          <v-tooltip bottom v-if="index > 2">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                color="primary"
                                @click="openDialogConfirmEmail(item)"
                              >
                                <v-icon>mdi mdi-email-arrow-right</v-icon>
                              </v-btn>
                            </template>
                            {{ `Kirim Email` }}
                          </v-tooltip>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- verifikasi -->
    <v-dialog v-model="isDialogOpenVerification" max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">Konfirmasi</span>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text
              >Yakin ide dengan judul "{{ titleSuggestion }}" sudah
              terimplementasi ?</v-text
            >
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenVerification = false"
            >Cancel</v-btn
          >
          <v-btn color="primary" @click="submitVerification">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- input score -->
    <v-dialog v-model="isDialogOpenInputScore" max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">Input Score</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValidInputScore">
            <v-text-field
              v-for="(criteria, index) in criteriaScoreList"
              :key="index"
              v-model="criteria.score"
              :label="`${criteria.name} ( 1 - 10 )`"
              :disabled="criteria.is_system === 1"
              type="number"
              :rules="[
                (v) =>
                  (v !== null && v !== '' && v >= 0 && v <= 10) ||
                  'Score harus antara 0 - 10',
              ]"
            ></v-text-field>

            <v-text-field
              v-model="formattedRealizationBenefit"
              v-show="isShowRelazationBenefit"
              label="Realisasi Benefit"
              :rules="[
                (v) => !!v || 'Realisasi benefit tidak boleh kosong',
                (v) => /^\d+(\.\d+)*$/.test(v) || 'Hanya boleh angka',
                (v) =>
                  parseInt(v.replace(/\./g, '')) >= 0 ||
                  'Realisasi benefit harus minimal 0',
              ]"
            ></v-text-field>

            <!-- <v-checkbox
              v-if="isShowTopIdea"
              v-model="topIdeaSelected"
              label="Top Idea"
            ></v-checkbox> -->
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenInputScore = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :disabled="!isFormValidInputScore"
            @click="submitInputScore"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Histori Persetujuan -->
    <v-dialog v-model="isDialogOpenApproval" max-width="700px">
      <v-card>
        <v-card-title class="headline">Histori Persetujuan</v-card-title>
        <v-data-table
          :headers="tableHeadersApproval"
          :items="approvalList"
          class="elevation-1"
        >
        </v-data-table>
      </v-card>
    </v-dialog>

    <!-- implement detail -->
    <v-dialog v-model="isDialogOpenDetail" max-width="500px">
      <v-card>
        <v-card-title class="headline">List Detail Score</v-card-title>
        <v-data-table
          :headers="tableHeadersDetail"
          :items="implementListDetail"
          class="elevation-1"
        >
        </v-data-table>
      </v-card>
    </v-dialog>

    <!-- reject -->
    <v-dialog v-model="isDialogOpenReject" max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">Konfirmasi</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValidReject">
            <v-text
              >Yakin ide dengan judul "{{ titleSuggestion }}" tidak implementasi
              ?</v-text
            >
            <v-text-field
              v-model="note"
              label="Catatan"
              required
              :rules="[(v) => !!v || 'Catatan tidak boleh kosong !']"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenReject = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :disabled="!isFormValidReject"
            @click="submitReject"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- is Top ten -->
    <v-dialog v-model="isDialogOpenConfirmTopTen" persistent max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">Konfirmasi</span>
        </v-card-title>
        <v-card-text>
          <v-form>
            <span>{{ textTopTen }}</span>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenConfirmTopTen = false"
            >Cancel</v-btn
          >
          <v-btn color="primary" @click="submitTopTen">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- done -->
    <v-dialog v-model="isDialogOpenDone" persistent max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">Konfirmasi</span>
        </v-card-title>
        <v-card-text>
          <v-form>
            <span>{{ textDone }}</span>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenDone = false"
            >Cancel</v-btn
          >
          <v-btn color="primary" @click="submitDone">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- is Top idea -->
    <v-dialog v-model="isDialogOpenTopIdea" persistent max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">Konfirmasi</span>
          <img
            :src="require(`@/assets/${pictCoint}.png`)"
            alt="Coint"
            class="flip-animation"
          />
        </v-card-title>
        <v-card-text>
          <v-form>
            <span>{{ textTopIdea }} </span>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenTopIdea = false"
            >Cancel</v-btn
          >
          <v-btn color="primary" @click="submitTopIdea">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- suggestion detail -->
    <v-dialog v-model="isDialogOpenSuggestionDetail" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            readonly
            v-model="suggestionDetail.title"
            label="Judul"
            required
          ></v-text-field>
          <v-textarea
            v-model="suggestionDetail.description"
            label="Latar belakang / Uraian masalah"
            require
            readonly
          ></v-textarea>
          <v-textarea
            v-model="suggestionDetail.suggestions"
            label="Solusi"
            type="suggestions"
            readonly
          ></v-textarea>
          <v-text-field
            v-model="formattedBenefitDetail"
            label="Potensi Benefit"
            type="text"
            readonly
          >
          </v-text-field>

          <v-textarea
            v-model="suggestionDetail.noted"
            label="Keterangan Biaya"
            readonly
          ></v-textarea>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenSuggestionDetail = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- to be revised -->
    <v-dialog v-model="isDialogOpenTbr" max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">Konfirmasi</span>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text
              >Yakin ide dengan judul "{{ titleSuggestion }}" To Be Revised
              ?</v-text
            >
            <v-text-field
              v-model="note"
              label="Catatan"
              required
              :rules="[(v) => !!v || 'Catatan tidak boleh kosong !']"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenTbr = false"
            >Cancel</v-btn
          >
          <v-btn color="primary" @click="submitTbr">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Email -->
    <v-dialog v-model="isDialogOpenEmail" persistent max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">Konfirmasi</span>
        </v-card-title>
        <v-card-text>
          <v-form>
            <span>{{ textEmail }}</span>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenEmail = false"
            >Cancel</v-btn
          >
          <v-btn color="primary" @click="submitEmail">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar Notifications -->
    <snackbarMessage />
  </v-container>
</template>

<script>
import api from "@/utils/api";
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import { getThisYearRange } from "@/utils/date";
import store from "@/store";

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
  },
  data() {
    return {
      awsObjectUrl: process.env.VUE_APP_AWS_OBJECT_URL,
      awsPath: process.env.VUE_APP_AWS_PATH,
      realizationBenefit: 0,
      isShowRelazationBenefit: false,
      tab: 0,
      tableHeadersApproval: [
        { text: "Name", align: "center", value: "step_name" },
        { text: "Status", align: "center", value: "status" },
        { text: "Catatan", align: "center", value: "comments" },
        { text: "Di Setujui Oleh", align: "center", value: "created_by_name" },
        { text: "Tanggal", align: "center", value: "created_on" },
      ],
      tableHeadersDetail: [
        { text: "Name", value: "criteria_score_name" },
        { text: "Score", value: "score" },
      ],
      tableHeaders: [
        { text: "Judul", align: "center", value: "title" },
        { text: "Kategori", align: "center", value: "category" },
        { text: "Potensi Benefit", align: "center", value: "benefit" },
        {
          text: "Histori Persetujuan",
          align: "center",
          value: "history_approval",
        },
        {
          text: "Bukti Implementasi",
          align: "center",
          value: "bukti_implementasi",
        },
        { text: "Dibuat Oleh", align: "center", value: "id" },
        { text: "Aksi", align: "center", value: "actions", sortable: false },
      ],
      tableHeadersVerified: [
        { text: "Judul", align: "center", value: "title" },
        { text: "Kategori", align: "center", value: "category" },
        { text: "Potensi Benefit", align: "center", value: "benefit" },
        {
          text: "Histori Persetujuan",
          align: "center",
          value: "history_approval",
        },
        {
          text: "Bukti Implementasi",
          align: "center",
          value: "bukti_implementasi",
        },
        // { text: "Score", align: "center", value: "score" },
        { text: "Dibuat Oleh", align: "center", value: "id" },
        { text: "Aksi", align: "center", value: "actions", sortable: false },
      ],
      tableHeadersTopTen: [
        { text: "Judul", align: "center", value: "title", sortable: false },
        {
          text: "Kategori",
          align: "center",
          value: "category",
          sortable: false,
        },
        {
          text: "Potensi Benefit",
          align: "center",
          value: "benefit",
          sortable: false,
        },
        // {
        //   text: "Realisasi Benefit",
        //   align: "center",
        //   value: "realization_benefit",
        //   sortable: false,
        // },

        {
          text: "Histori Persetujuan",
          align: "center",
          value: "history_approval",
          sortable: false,
        },
        {
          text: "Bukti Implementasi",
          align: "center",
          value: "bukti_implementasi",
          sortable: false,
        },
        {
          text: "Materi Presentasi",
          align: "center",
          value: "materi_presentasi",
          sortable: false,
        },
        { text: "Score", align: "center", value: "score", sortable: false },
        {
          text: "Top Ten",
          align: "center",
          value: "is_top_ten",
          sortable: false,
        },
        // {
        //   text: "Top Idea",
        //   align: "center",
        //   value: "top_idea",
        //   sortable: false,
        // },

        { text: "Dibuat Oleh", align: "center", value: "id", sortable: false },
        { text: "Aksi", align: "center", value: "actions", sortable: false },
      ],
      tableHeadersTopIdea: [
        { text: "Judul", align: "center", value: "title", sortable: false },
        {
          text: "Kategori",
          align: "center",
          value: "category",
          sortable: false,
        },
        {
          text: "Potensi Benefit",
          align: "center",
          value: "benefit",
          sortable: false,
        },
        {
          text: "Realisasi Benefit",
          align: "center",
          value: "realization_benefit",
          sortable: false,
        },
        {
          text: "Histori Persetujuan",
          align: "center",
          value: "history_approval",
          sortable: false,
        },
        {
          text: "Bukti Implementasi",
          align: "center",
          value: "bukti_implementasi",
          sortable: false,
        },
        {
          text: "Materi Presentasi",
          align: "center",
          value: "materi_presentasi",
          sortable: false,
        },
        { text: "Score", align: "center", value: "score", sortable: false },
        {
          text: "Top Idea",
          align: "center",
          value: "is_top_idea",
          sortable: false,
        },
        { text: "Dibuat Oleh", align: "center", value: "id", sortable: false },
        { text: "Aksi", align: "center", value: "actions", sortable: false },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "id",
        sortDesc: true,
        startMenu: false,
        endMenu: false,
        startDate: getThisYearRange().start,
        endDate: getThisYearRange().end,
        search: "",
      },
      paginationVerified: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "id",
        sortDesc: true,
        startMenu: false,
        endMenu: false,
        startDate: getThisYearRange().start,
        endDate: getThisYearRange().end,
        search: "",
      },
      paginationTopTen: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "score",
        sortDesc: true,
        startDate: getThisYearRange().start,
        endDate: getThisYearRange().end,
        search: "",
      },
      paginationTopIdea: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "score",
        sortDesc: true,
        startDate: getThisYearRange().start,
        endDate: getThisYearRange().end,
        search: "",
      },
      totalImplements: 0,
      totalImplementsVerified: 0,
      totalImplementsTopTen: 0,
      totalImplementsTopIdea: 0,
      implementsList: [],
      implementsListVerified: [],
      implementsListTopTen: [],
      implementsListTopIdea: [],
      approvalList: [],
      isLoading: false,
      isLoadingVerified: false,
      isLoadingTopTen: false,
      isLoadingTopIdea: false,
      isLoadingEmail: false,
      isDialogOpenDetail: false,
      isDialogOpenReject: false,
      isDialogOpenTopIdea: false,
      isFormValidVerification: false,
      isFormValid: false,
      isFormValidInputScore: false,
      isFormValidReject: false,
      isFormValidTbr: false,
      isDialogOpenVerification: false,
      isDialogOpenTbr: false,
      isDialogOpenInputScore: false,
      isDialogOpenConfirmTopTen: false,
      isDialogOpenDone: false,
      isDialogOpenApproval: false,
      isDialogOpenSuggestionDetail: false,
      isDialogOpenUploadMateri: false,
      isDialogOpenEmail: false,
      isDisabledDone: false,
      criteriaScoreList: [],
      implement: null,
      implementId: null,
      suggestionId: null,
      implementListDetail: [],
      titleSuggestion: null,
      note: null,
      isShowTopIdea: false,
      isShowBtnInputScoreTopIdea: true,
      textTopTen: null,
      textDone: null,
      textTopIdea: null,
      textEmail: null,
      orderTopIdea: null,
      suggestionDetail: {
        id: null,
        suggestion_category_id: null,
        title: "",
        description: "",
        suggestions: "",
        benefit: 0,
        noted: "",
      },
      dialogTitle: "",
      pictCoint: "gold",
    };
  },
  methods: {
    async fetchCriteriaScore(sequence_score) {
      await api
        .get("/criteria-score")
        .then(({ data }) => {
          if (parseInt(sequence_score) > 0) {
            this.criteriaScoreList = data.data.data.filter(
              (item) => item.sequence == sequence_score
            );
          }

          // console.log(this.sequence_score);
          // console.log(this.criteriaScoreList);
        })
        .catch((error) => {
          console.error("Error fetching criteria score:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    async fetchImplementDetail(implement_id, secuence_score) {
      await api
        .get(
          `/implements/detail?implementId=${implement_id}&sequenceScore=${secuence_score}`
        )
        .then(({ data }) => {
          this.implementListDetail = data.data;
          // console.log(this.implementListDetail);
          this.isDialogOpenDetail = true;
        })
        .catch((error) => {
          console.error("Error fetching criteria score:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    async fetchImplementVerification() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;
      const query = this.$route.query;

      const params = {
        page: parseInt(query.page) || this.pagination.page,
        limit: parseInt(query.itemsPerPage) || this.pagination.itemsPerPage,
        search: query.search || this.pagination.search,
        sortBy: query.sortBy || this.pagination.sortBy || "id",
        sortDesc: query.sortDesc || this.pagination.sortDesc || true,
        isVerified: 0,
        isTopTen: 0,
        isTopIdea: 0,
        startDate: query.startDate || this.pagination.startDate,
        endDate: query.endDate || this.pagination.endDate,
      };

      await api
        .get("/implements", { params })
        .then(({ data }) => {
          // console.log(data);
          this.implementsList = data.data.data;
          this.totalImplements = data.data.total;
        })
        .catch((error) => {
          console.error("Error fetching implements:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },
    async fetchImplementVerified() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoadingVerified = true;
      const query = this.$route.query;

      const params = {
        page: parseInt(query.page) || this.paginationVerified.page,
        limit:
          parseInt(query.itemsPerPage) || this.paginationVerified.itemsPerPage,
        search: query.search || this.paginationVerified.search,
        sortBy: query.sortBy || this.paginationVerified.sortBy || "id",
        sortDesc: query.sortDesc || this.paginationVerified.sortDesc || true,
        isVerified: 1,
        startDate: query.startDate || this.paginationVerified.startDate,
        endDate: query.endDate || this.paginationVerified.endDate,
      };

      await api
        .get("/implements", { params })
        .then(({ data }) => {
          // console.log(data);
          this.implementsListVerified = data.data.data;
          this.totalImplementsVerified = data.data.total;
        })
        .catch((error) => {
          console.error("Error fetching implements verified:", error);
        })
        .finally(() => {
          this.isLoadingVerified = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },
    async fetchImplementTopTen() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoadingTopTen = true;
      const query = this.$route.query;

      const params = {
        page: parseInt(query.page) || this.paginationTopTen.page,
        limit:
          parseInt(query.itemsPerPage) || this.paginationTopTen.itemsPerPage,
        search: query.search || this.paginationTopTen.search,
        sortBy: "score",
        sortDesc: true,
        startDate: query.startDate || this.paginationTopTen.startDate,
      };

      await api
        .get("/implements/top-ten", { params })
        .then(({ data }) => {
          // console.log(data.data.data.length);
          this.implementsListTopTen = data.data.data;
          this.totalImplementsTopTen = data.data.data.length;

          this.isDisabledDone = false;
          for (let i = 0; i < this.implementsListTopTen.length; i++) {
            if (this.implementsListTopTen[i].is_top_ten) {
              this.isDisabledDone = true;
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching implements:", error);
        })
        .finally(() => {
          this.isLoadingTopTen = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },
    async fetchImplementTopIdea() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoadingTopTen = true;
      const query = this.$route.query;

      const params = {
        page: parseInt(query.page) || this.paginationTopIdea.page,
        limit:
          parseInt(query.itemsPerPage) || this.paginationTopIdea.itemsPerPage,
        search: query.search || this.paginationTopIdea.search,
        sortBy: "score",
        sortDesc: true,
        isVerified: 1,
        isTopTen: 1,
        isTopIdea: 1,
        secuenceScore: 1,
        startDate: query.startDate || this.paginationTopIdea.startDate,
      };

      await api
        .get("/implements/top-idea", { params })
        .then(({ data }) => {
          // console.log(data);
          this.implementsListTopIdea = data.data.data;
          this.totalImplementsTopIdea = data.data.total;
          this.isShowBtnInputScoreTopIdea = true;
          for (let i = 0; i < this.implementsListTopIdea.length; i++) {
            if (this.implementsListTopIdea[i].is_top_idea) {
              this.isShowBtnInputScoreTopIdea = false;
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching implements:", error);
        })
        .finally(() => {
          this.isLoadingTopTen = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },
    async openDialogVerification(implement) {
      this.implementId = implement.id;
      this.suggestionId = implement.suggestion_id;
      this.titleSuggestion = implement.title;
      this.isDialogOpenVerification = true;
    },
    async openDialogTbr(implement) {
      this.implementId = implement.id;
      this.suggestionId = implement.suggestion_id;
      this.titleSuggestion = implement.title;
      this.isDialogOpenTbr = true;
    },
    async openDialogInputScore(implement, sequence_score) {
      // console.log(implement);
      this.realizationBenefit = 0;
      await this.fetchCriteriaScore(sequence_score);
      this.implementId = implement.id;
      this.suggestionId = implement.suggestion_id;
      this.benefit = implement.benefit;

      if (sequence_score < 2) {
        for (let i = 0; i < this.criteriaScoreList.length; i++) {
          if (
            this.criteriaScoreList[i].name ==
            "Potensial Value (Penghematan Biaya atau Peningkatan Produktivitas)"
          ) {
            this.criteriaScoreList[i].score = await this.countScoreBenefit(
              this.benefit
            );
          }
        }

        this.isShowTopIdea = false;
        this.isShowRelazationBenefit = false;
        this.realizationBenefit = 0;
      } else {
        this.isShowRelazationBenefit = true;
        this.isShowTopIdea = true;
      }

      //  console.log(this.criteriaScoreList);

      this.isDialogOpenInputScore = true;
    },
    async openDialogConfirmTopTen(implement) {
      this.implement = implement;
      this.implementId = implement.id;
      this.suggestionId = implement.suggestion_id;
      this.titleSuggestion = implement.title;
      this.textTopTen = `Yakin ide dengan judul "${this.titleSuggestion}" ini terpilih sebagai top ten ?`;
      this.isDialogOpenConfirmTopTen = true;
    },
    openDialogReject(implement) {
      this.implementId = implement.id;
      this.suggestionId = implement.suggestion_id;
      this.titleSuggestion = implement.title;
      this.isDialogOpenReject = true;
    },
    async openDialogConfirmTopIdea(implement, orderTopIdea) {
      if (parseInt(orderTopIdea) === 0) {
        this.pictCoint = "gold";
        this.textTopIdea = `Yakin ide dengan judul "${this.titleSuggestion}" ini terpilih sebagai top idea gold ?`;
      } else if (parseInt(orderTopIdea) === 1) {
        this.pictCoint = "silver";
        this.textTopIdea = `Yakin ide dengan judul "${this.titleSuggestion}" ini terpilih sebagai top idea silver ?`;
      } else if (parseInt(orderTopIdea) === 2) {
        this.pictCoint = "bronze";
        this.textTopIdea = `Yakin ide dengan judul "${this.titleSuggestion}" ini terpilih sebagai top idea bronze ?`;
      } else {
        this.textTopIdea = ``;
      }
      this.orderTopIdea = orderTopIdea;
      this.implement = implement;
      this.implementId = implement.id;
      this.suggestionId = implement.suggestion_id;
      this.titleSuggestion = implement.title;
      this.isDialogOpenTopIdea = true;
    },
    openDialogHistoriApproval(id) {
      api
        .get(`/approvals/by-suggestion-id/${id}`)
        .then(({ data }) => {
          this.approvalList = data.data;
          this.isDialogOpenApproval = true;
        })
        .catch((error) => {
          this.approvalList = [];
          this.isDialogOpenApproval = true;
          console.error("Error fetching position:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    openDialogSuggestionDetail(params = null) {
      // console.log(params);
      this.selectedSuggestionCategoryId = params.suggestion_category_id;
      this.dialogTitle = "Detail Suggestion";
      this.suggestionDetail = { ...params };
      this.isDialogOpenSuggestionDetail = true;
    },
    openDialogConfirmEmail(implement) {
      this.implement = implement;
      this.implementId = implement.id;
      this.suggestionId = implement.suggestion_id;
      this.textEmail = `Yakin ingin mengirim email ke user "${implement.created_by_name}"`;
      this.isDialogOpenEmail = true;
    },
    async openDialogDone() {
      this.textDone = `Yakin "${this.implementsListTopTen.length}" ide ini terpilih sebagai top ten ?`;
      this.isDialogOpenDone = true;
    },
    downloadAttachment(suggestionId, fileName) {
      // console.log(this.awsObjectUrl);
      // console.log(this.awsPath);
      window.open(
        `${this.awsObjectUrl}${this.awsPath}document/implemented/${suggestionId}/${fileName}`,
        "_blank"
      );
    },
    downloadMateri(id, fileName) {
      // console.log(pathName);
      window.open(
        `${this.awsObjectUrl}${this.awsPath}document/materi/${id}/${fileName}`,
        "_blank"
      );
    },
    countScoreBenefit(benefit) {
      switch (true) {
        case benefit >= 1000000000:
          return 10;
        case benefit >= 750000000:
          return 9;
        case benefit >= 250000000:
          return 8;
        case benefit >= 100000000:
          return 7;
        case benefit >= 50000000:
          return 6;
        case benefit >= 10000000:
          return 5;
        case benefit >= 7500000:
          return 4;
        case benefit >= 5000000:
          return 3;
        case benefit >= 2500000:
          return 2;
        default:
          return 1;
      }
    },
    countScoreRealisasiBenefitVsPotensialValue(benefit, realization_benefit) {
      const persentase = realization_benefit / benefit;
      // console.log(persentase);
      if (persentase === 0 || isNaN(persentase)) return 0;

      switch (true) {
        case persentase >= 0.95:
          return 10;
        case persentase >= 0.9:
          return 9;
        case persentase >= 0.75:
          return 8;
        case persentase >= 0.7:
          return 7;
        case persentase >= 0.55:
          return 6;
        case persentase >= 0.5:
          return 5;
        case persentase >= 0.35:
          return 4;
        case persentase >= 0.3:
          return 3;
        case persentase >= 0.15:
          return 2;
        default:
          return 1;
      }
    },
    formatRupiah(value) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0, // Tidak ada angka desimal
      }).format(value);
    },

    submitVerification() {
      store.dispatch("showLoading");

      const payload = {
        implementId: this.implementId,
        suggestionId: this.suggestionId,
        is_verified: 1,
      };
      // console.log(payload);

      api
        .post("/implements/update/verification", payload)
        .then((response) => {
          const message = response.data.message;
          this.fetchImplementVerification();
          this.fetchImplementVerified();
          this.fetchImplementTopTen();
          this.fetchImplementTopIdea();
          this.isDialogOpenVerification = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save!";

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoadingVerification = false;
          store.dispatch("hideLoading");
        });
    },
    submitInputScore() {
      store.dispatch("showLoading");
      const cleanData = [];
      this.criteriaScoreList.forEach((obj) => {
        cleanData.push({
          criteria_score_id: obj.id,
          score: obj.score,
          sequence: obj.sequence,
        });
      });

      const payload = {
        realization_benefit: this.realizationBenefit,
        implement_id: this.implementId,
        suggestion_id: this.suggestionId,
        detail: cleanData,
      };
      // console.log(payload);

      api
        .post("/implements/update/input-score", payload)
        .then((response) => {
          const message = response.data.message;
          this.fetchImplementVerification();
          this.fetchImplementVerified();
          this.fetchImplementTopTen();
          this.fetchImplementTopIdea();
          this.isDialogOpenInputScore = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save!";

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.isShowTopIdea = false;
          this.realizationBenefit = 0;
          store.dispatch("hideLoading");
        });
    },
    submitReject() {
      store.dispatch("showLoading");

      if (!this.note) {
        store.dispatch("triggerSnackbar", {
          message: "Catatan tidak boleh kosong !",
          isSuccess: false,
        });
        store.dispatch("hideLoading");
        return;
      }

      const payload = {
        implementId: this.implementId,
        suggestionId: this.suggestionId,
        note: this.note,
      };

      // console.log(payload);

      api
        .post("/implements/update/reject", payload)
        .then((response) => {
          const message = response.data.message;
          this.fetchImplementVerification();
          this.fetchImplementVerified();
          this.fetchImplementTopTen();
          this.fetchImplementTopIdea();
          this.isDialogOpenReject = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save!";

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    submitTbr() {
      store.dispatch("showLoading");

      if (!this.note) {
        store.dispatch("triggerSnackbar", {
          message: "Catatan tidak boleh kosong !",
          isSuccess: false,
        });
        store.dispatch("hideLoading");
        return;
      }

      const payload = {
        implementId: this.implementId,
        suggestionId: this.suggestionId,
        note: this.note,
      };

      // console.log(payload);

      api
        .post("/implements/update/to-be-revised", payload)
        .then((response) => {
          const message = response.data.message;
          this.fetchImplementVerification();
          this.fetchImplementVerified();
          this.fetchImplementTopTen();
          this.fetchImplementTopIdea();
          this.isDialogOpenTbr = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save!";

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    submitTopTen() {
      store.dispatch("showLoading");

      const payload = {
        isTopTen: 1,
        implementId: this.implementId,
        suggestionId: this.suggestionId,
      };
      // console.log(payload);

      api
        .post("/implements/update/top-ten", payload)
        .then((response) => {
          const message = response.data.message;
          this.fetchImplementVerification();
          this.fetchImplementVerified();
          this.fetchImplementTopTen();
          this.fetchImplementTopIdea();
          this.isDialogOpenConfirmTopTen = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save!";

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoadingTopIdea = false;
          store.dispatch("hideLoading");
        });
    },
    submitDone() {
      store.dispatch("showLoading");
      let arrayPayload = [];
      for (let i = 0; i < this.implementsListTopTen.length; i++) {
        arrayPayload.push({
          implementId: this.implementsListTopTen[i].id,
          suggestionId: this.implementsListTopTen[i].suggestion_id,
        });
      }

      const payload = {
        isTopTen: 1,
        data: arrayPayload,
      };
      // console.log(payload);

      api
        .post("/implements/update/top-ten/done", payload)
        .then((response) => {
          const message = response.data.message;
          this.fetchImplementVerification();
          this.fetchImplementVerified();
          this.fetchImplementTopTen();
          this.fetchImplementTopIdea();
          this.isDialogOpenDone = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save!";

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoadingTopIdea = false;
          store.dispatch("hideLoading");
        });
    },
    submitTopIdea() {
      store.dispatch("showLoading");

      const payload = {
        orderTopIdea: this.orderTopIdea,
        isTopIdea: 1,
        implementId: this.implementId,
        suggestionId: this.suggestionId,
      };
      // console.log(payload);

      api
        .post("/implements/update/top-idea", payload)
        .then((response) => {
          const message = response.data.message;
          this.fetchImplementVerification();
          this.fetchImplementVerified();
          this.fetchImplementTopTen();
          this.fetchImplementTopIdea();
          this.isDialogOpenTopIdea = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save!";

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoadingTopIdea = false;
          store.dispatch("hideLoading");
        });
    },

    submitEmail() {
      store.dispatch("showLoading");

      const payload = {
        implementId: this.implementId,
        suggestionId: this.suggestionId,
      };
      // console.log(payload);

      api
        .post("/implements/email", payload)
        .then((response) => {
          const message = response.data.message;
          this.fetchImplementTopIdea();
          this.isDialogOpenEmail = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save!";

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoadingEmail = false;
          store.dispatch("hideLoading");
        });
    },

    fileList(fileNames) {
      return fileNames ? fileNames.split("|") : [];
    },
    getFileIcon(fileName) {
      const extension = fileName.split(".").pop().toLowerCase();
      const icons = {
        xlsx: "mdi-file-excel-outline",
        jpeg: "mdi-image",
        png: "mdi-image",
        jpg: "mdi-image",
        pdf: "mdi-file-pdf-box",
        mp4: "mdi-video-box",
      };
      return icons[extension] || "mdi-file-download-outline";
    },
    updateQuery(key, value) {
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePagination(this.$route.query);
    },
    updateQueryVerified(key, value) {
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePaginationVerified(this.$route.query);
    },
    updateQueryTopTen(key, value) {
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePaginationTopTen(this.$route.query);
    },
    updateQueryTopIdea(key, value) {
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePaginationTopIdea(this.$route.query);
    },
    debouncedSearch() {
      this.updateQuery("search", this.pagination.search);
    },
    debouncedSearchVerified() {
      this.updateQueryVerified("search", this.paginationVerified.search);
    },
    debouncedSearchTopTen() {
      this.updateQuery("search", this.paginationTopTen.search);
    },
    debouncedSearchTopIdea() {
      this.updateQuery("search", this.paginationTopIdea.search);
    },
    updatePagination(query) {
      // console.log(query);
      this.pagination.page = parseInt(query.page) || 1;
      this.pagination.itemsPerPage = parseInt(query.itemsPerPage) || 10;
      this.pagination.sortBy = query.sortBy || "id";
      this.pagination.sortDesc = query.sortDesc === "true" ? true : false;
      this.pagination.search = query.search || this.pagination.search || "";
      this.pagination.startDate = query.startDate || this.pagination.startDate;
      this.pagination.endDate = query.endDate || this.pagination.endDate;
    },
    updatePaginationVerified(query) {
      // console.log(query);
      this.paginationVerified.page = parseInt(query.page) || 1;
      this.paginationVerified.itemsPerPage = parseInt(query.itemsPerPage) || 10;
      this.paginationVerified.sortBy = query.sortBy || "id";
      this.paginationVerified.sortDesc =
        query.sortDesc === "true" ? true : false;
      this.paginationVerified.search =
        query.search || this.paginationVerified.search || "";
      this.paginationVerified.startDate =
        query.startDate || this.paginationVerified.startDate;
      this.paginationVerified.endDate =
        query.endDate || this.paginationVerified.endDate;
    },
    updatePaginationTopTen(query) {
      this.paginationTopTen.page = parseInt(query.page) || 1;
      this.paginationTopTen.itemsPerPage = parseInt(query.itemsPerPage) || 10;
      this.paginationTopTen.sortBy = query.sortBy || "id";
      this.paginationTopTen.sortDesc = query.sortDesc === "true" ? true : false;
      this.paginationTopTen.search =
        query.search || this.paginationTopTen.search || "";
      this.paginationTopTen.startDate =
        query.startDate || this.paginationTopTen.startDate;
      this.paginationTopTen.endDate =
        query.endDate || this.paginationTopTen.endDate;
    },
    updatePaginationTopIdea(query) {
      // console.log(query);
      this.paginationTopIdea.page = parseInt(query.page) || 1;
      this.paginationTopIdea.itemsPerPage = parseInt(query.itemsPerPage) || 10;
      this.paginationTopIdea.sortBy = query.sortBy || "id";
      this.paginationTopIdea.sortDesc =
        query.sortDesc === "true" ? true : false;
      this.paginationTopIdea.search =
        query.search || this.paginationTopIdea.search || "";
      this.paginationTopIdea.startDate =
        query.startDate || this.paginationTopIdea.startDate;
      this.paginationTopIdea.endDate =
        query.endDate || this.paginationTopIdea.endDate;
    },

    onDateChange(param) {
      if (param === "start") {
        this.updateQuery("startDate", this.pagination.startDate); // Update startDate
      } else {
        this.updateQuery("endDate", this.pagination.endDate); // Update endDate
      }

      this.updatePaginationVerified(this.$route.query);
      this.updatePaginationTopTen(this.$route.query);
      this.updatePaginationTopIdea(this.$route.query);
    },
    onDateChangeVerified(param) {
      if (param === "start") {
        this.updateQueryVerified(
          "startDate",
          this.paginationVerified.startDate
        ); // Update pagination.startDate
      } else {
        this.updateQueryVerified("endDate", this.paginationVerified.endDate); // Update pagination.endDate
      }

      this.updatePagination(this.$route.query);
      this.updatePaginationTopTen(this.$route.query);
      this.updatePaginationTopIdea(this.$route.query);
    },
    onDateChangeTopTen(param) {
      if (param === "start") {
        this.updateQueryTopTen("startDate", this.paginationTopTen.startDate); // Update pagination.startDate
      } else {
        this.updateQueryTopTen("endDate", this.paginationTopTen.endDate); // Update pagination.endDatethis.updateQueryTopIdea("endDate", this.paginationTopIdea.endDate); // Update pagination.endDate
      }
      this.updatePagination(this.$route.query);
      this.updatePaginationVerified(this.$route.query);
      this.updatePaginationTopIdea(this.$route.query);
    },
    onDateChangeTopIdea(param) {
      if (param === "start") {
        this.updateQueryTopIdea("startDate", this.paginationTopIdea.startDate); // Update pagination.startDate
      } else {
        this.updateQueryTopIdea("endDate", this.paginationTopIdea.endDate); // Update pagination.endDate
      }
      this.updatePagination(this.$route.query);
      this.updatePaginationVerified(this.$route.query);
      this.updatePaginationTopTen(this.$route.query);
    },
  },
  watch: {
    pagination: {
      handler: "fetchImplementVerification",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
    },
    paginationVerified: {
      handler: "fetchImplementVerified",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
    },
    paginationTopTen: {
      handler: "fetchImplementTopTen",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
    },
    paginationTopIdea: {
      handler: "fetchImplementTopIdea",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
    },
  },
  computed: {
    tabItems() {
      return [
        { name: "Verifikasi", total: this.totalImplements },
        {
          name: "Implementasi",
          total: this.totalImplementsVerified,
        },
        { name: "Top 10", total: this.totalImplementsTopTen },
        { name: "Top Idea", total: this.totalImplementsTopIdea },
      ];
    },
    user() {
      return store.getters["user/getUser"] || {}; // get Data User
    },
    formattedRealizationBenefit: {
      get() {
        return new Intl.NumberFormat("id-ID").format(this.realizationBenefit);
      },
      set(value) {
        // Hapus titik saat input berubah, agar tetap bisa menyimpan angka asli
        this.realizationBenefit = parseInt(value.replace(/\./g, "")) || 0;
        const scoreRealizationBenefit = this.countScoreBenefit(
          this.realizationBenefit
        );
        // console.log(this.benefit);
        // console.log(this.realizationBenefit);
        const scoreRealisasiBenefitVsPotensialValue =
          this.countScoreRealisasiBenefitVsPotensialValue(
            this.benefit,
            this.realizationBenefit
          );
        for (let i = 0; i < this.criteriaScoreList.length; i++) {
          if (
            this.criteriaScoreList[i].name ==
            "Value (Penghematan Biaya atau Peningkatan Produktivitas)"
          ) {
            this.criteriaScoreList[i].score = scoreRealizationBenefit;
          } else if (
            this.criteriaScoreList[i].name ==
            "Persentase Realisasi Benefit terhadap Potensial Value Cost Saving"
          ) {
            this.criteriaScoreList[i].score =
              scoreRealisasiBenefitVsPotensialValue;
          }
        }
      },
    },
    formattedBenefitDetail: {
      get() {
        return new Intl.NumberFormat("id-ID").format(
          this.suggestionDetail.benefit
        );
      },
      set(value) {
        // Hapus titik saat input berubah, agar tetap bisa menyimpan angka asli
        this.suggestionDetail.benefit = parseInt(value.replace(/\./g, "")) || 0;
      },
    },
  },
  mounted() {
    store.commit("setTitle", "Implementasi");
    this.fetchImplementVerification();
    this.fetchImplementVerified();
    this.fetchImplementTopTen();
    this.fetchImplementTopIdea();
    // this.updatePagination(this.$route.query);
    // this.updatePaginationVerified(this.$route.query);
  },
};
</script>

<style scoped>
.v-data-table td:nth-child(3),
td:nth-child(4),
td:nth-child(5),
td:nth-child(6),
td:nth-child(7) {
  text-align: center;
}

.flip-animation {
  width: 21px; /* Sesuaikan ukuran gambar */
  height: 21px; /* Sesuaikan ukuran gambar */
  object-fit: contain; /* Agar gambar tidak terpotong */
  display: block; /* Menghindari ukuran mengecil */
  margin: auto; /* Agar tetap di tengah */
  animation: flip 20s infinite linear;
  margin-left: 5px;
}

@keyframes flip {
  0% {
    transform: rotateY(0deg);
  }
  100% {
    transform: rotateY(360deg);
  }
}
</style>
